import { storeWrapper } from '../storeWrapper'

const initialState = {
  existingClient: null,
  newClientNo: '',
  isNew: true,
  namedClients: [],
  highRisk: false,
  billingHouse: '',
  billingArea: '',
  billingPostalTown: '',
  billingCounty: '',
  billingPostcode: '',
  billingAddressee: '',
  debtorLimit: '',
  wipLimit: '',
  disbursementsLimit: '',
  groupCode: null,
  clientPhones: [],
  customDataPageFieldValues: [],
  extensionFields: [],
  extensionValues: {}
}

export const useNewClientStore = storeWrapper('useNewClientStore', (set, get) => ({
  ...initialState,
  updateState: ({ key, value }) => set({ [key]: value }),
  updateWizardClientState: ({ clientData, customDataPageFieldValues }) => {
    set({
      existingClient: clientData ?? null,
      isNew: false,
      namedClients: clientData.namedClients ?? [],
      highRisk: clientData.highRisk ?? false,
      billingHouse: clientData.billingHouse ?? clientData.house ?? '',
      billingArea: clientData.billingArea ?? clientData.area ?? '',
      billingPostalTown: clientData.billingPostalTown ?? clientData.postalTown ?? '',
      billingCounty: clientData.billingCounty ?? clientData.county ?? '',
      billingPostcode: clientData.billingPostcode ?? clientData.postcode ?? '',
      billingAddressee: clientData.billingAddressee ?? clientData.clientName ?? '',
      debtorLimit: clientData.debtorLimit ?? '',
      wipLimit: clientData.wipLimit ?? '',
      disbursementsLimit: clientData.disbursementsLimit ?? '',
      groupCode: clientData.groupCode ?? null,
      clientPhones: clientData.clientPhones ?? [],
      customDataPageFieldValues: customDataPageFieldValues ?? []
    })
  },
  getNewClientPayload: () => {
    // if a new client is being created, use newClientNo. If an existing client was selected in the COIS wizard, use existingClient
    const {
      isNew,
      existingClient,
      newClientNo,
      namedClients,
      highRisk,
      billingHouse,
      billingArea,
      billingPostalTown,
      billingCounty,
      billingPostcode,
      billingAddressee,
      debtorLimit,
      wipLimit,
      disbursementsLimit,
      groupCode,
      clientPhones,
      customDataPageFieldValues
    } = get()

    if (!isNew) {
      return {
        isNew: false,
        clientNo: existingClient?.clientNo || null,
        customDataPageFieldValues: [],
        clientPhones: [],
        namedClients: []
      }
    }

    return {
      isNew: true,
      clientNo: String(newClientNo),
      namedClients: namedClients.map((client) => {
        const updatedClient = { ...client }
        delete updatedClient.id
        return updatedClient
      }),
      clientPhones: clientPhones
        ? clientPhones.map((phone) => {
            const updatedPhone = { ...phone }
            updatedPhone.phoneType = phone.phoneType?.phoneTypeId || null
            delete updatedPhone.id
            return updatedPhone
          })
        : null,
      debtorLimit: debtorLimit || null,
      disbursementsLimit: disbursementsLimit || null,
      wipLimit: wipLimit || null,
      groupCode: groupCode?.code,
      highRisk,
      billingHouse,
      billingArea,
      billingPostalTown,
      billingCounty,
      billingPostcode,
      billingAddressee,
      customDataPageFieldValues
    }
  },
  resetWizardClientState: () => {
    set(initialState)
  },
  reset: () => {
    set(initialState)
  }
}))
